import { render, staticRenderFns } from "./talents.vue?vue&type=template&id=a9a3d42a&scoped=true"
import script from "./talents.vue?vue&type=script&lang=js"
export * from "./talents.vue?vue&type=script&lang=js"
import style0 from "./talents.vue?vue&type=style&index=0&id=a9a3d42a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a3d42a",
  null
  
)

export default component.exports